import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { InsuranceFlowStatus } from 'src/app/enums/insurance-flow/insurance-flow-status.enum';
import { IconsModule } from 'src/app/shared/icons/icons.module';

import { BaseStepperAction } from '../base-action';
import { CancelPolicyModalComponent } from './cancel-policy-modal.component';

/** Mirrors the server's `CANCELLABLE_POLICY_STATUSES`. */
const CANCELLABLE_POLICY_STATUSES: InsuranceFlowStatus[] = [
  InsuranceFlowStatus.POLICY_ACTIVE,
  InsuranceFlowStatus.PENDING_ACTIVATION,
  InsuranceFlowStatus.POLICY_SUSPENDED,
];

@Component({
  selector: 'app-cancel-policy-action',
  standalone: true,
  imports: [
    CommonModule,
    NgbTooltipModule,
    CancelPolicyModalComponent,
    IconsModule,
  ],
  templateUrl: './cancel-policy.component.html',
})
export class CancelPolicyStepperActionComponent extends BaseStepperAction {
  get flow() {
    return this.state?.insuranceFlowData;
  }

  /**
   * A policy an insurer can be asked to terminate: in force, about to be, or
   * suspended. The server refuses every other status, so offering the action
   * elsewhere would only produce an error. Opening one is a write, so a
   * read-only agent never sees it.
   */
  get enabled(): boolean {
    const status = this.state?.insuranceFlowData?.status;
    return (
      !!this.state?.canEdit &&
      !!status &&
      CANCELLABLE_POLICY_STATUSES.includes(status)
    );
  }
}
